/**
 * Dates as the registry prints them.
 *
 * en-GB throughout, because the format a dealer writes — "04 Feb 2026" — is
 * the one the design prints, and a date that read differently for two people
 * looking at the same record would be two facts where the record has one.
 * Four screens had grown byte-identical copies of the short form and two of
 * the long form; the options on the short form are exactly the ways those
 * copies differed.
 *
 * THE SHORT FORM MOVED AGAIN, to `@ondo/shared`, and for the same reason it
 * moved here. OND-67 took the collector-list export off the browser, so the
 * SERVER writes a "Last activity" column into the exported file and the file
 * and the screen have to agree about what a day looks like. It is re-exported
 * rather than re-implemented, so every existing `formatDay` call site is
 * untouched and there is still one body.
 */

/** '04 Feb 2026'. See `formatRegistryDay` — this is that function. */
export { formatRegistryDay as formatDay } from "@ondo/shared";

/**
 * '14 March 2026'. The long form, for a date that carries a sentence —
 * "Assigned 14 March 2026", "Sent 22 July 2026".
 *
 * Deliberately unguarded, as both callers it replaced were: each prints a
 * `createdAt` the database issued, and the guard would have to choose a word
 * for a gap that neither screen has copy for.
 */
export function formatLongDay(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
